export enum SachetTypeEnum {

    RED = 'Rojo (500 kcal)',
    YELLOW = 'Amarillo (270 kcal)',
    EDIT = ' - '
}
